'use client';

import { useState } from 'react';
import { Button } from '@/components/ui/button';

export function SupportContactButton() {
  const [revealed, setRevealed] = useState(false);

  if (!revealed) {
    return (
      <Button
        onClick={() => setRevealed(true)}
        className="bg-[#001489] hover:bg-blue-900 text-white"
      >
        Contact Support
      </Button>
    );
  }

  return (
    <div className="rounded-lg border border-sky-200 bg-sky-50 p-4 space-y-2 inline-block text-left">
      <p className="text-sm font-semibold text-[#001489]">Zamzi Connect Support</p>
      <p className="text-sm">
        Email:{' '}
        <a href="mailto:ovaldaze@gmail.com" className="underline text-[#001489]">
          ovaldaze@gmail.com
        </a>
      </p>
      <p className="text-sm">
        WhatsApp:{' '}
        <a
          href="https://wa.me/27774584896"
          className="underline text-[#001489]"
          target="_blank"
          rel="noopener noreferrer"
        >
          +27 77 458 4896
        </a>
      </p>
      <p className="text-xs text-muted-foreground mt-1">
        Response times as per the SLA below. Please include your registered email and profile URL in your message.
      </p>
    </div>
  );
}
